import {useEffect} from 'react';

import {FormFieldRefOptions, InputForm} from '@netx/core-components/Form';

/**
 * @deprecated use react-hook-form instead
 */
export const useFormInput = (
	fieldName: string,
	value: any,
	form?: InputForm,
	options?: FormFieldRefOptions,
) => {
	// Setup/teardown
	useEffect(() => {
		if (!form || !fieldName) return;
		const _fieldName = fieldName;
		form.register(fieldName, options);
		form.setValue(fieldName, value);
		return () => {
			form.unregister(_fieldName);
		};
	}, [fieldName]);

	useEffect(() => {
		if (!form || !fieldName) return;
		form.updateOptions(fieldName as any, options || {});
	}, [options?.required, options?.validator, options?.hasChanged]);

	useEffect(() => {
		if (!form || !fieldName) return;
		form.setValue(fieldName, value);
	}, [value]);
};

export default useFormInput;
